import type { ReactNode } from 'react';
import { Container } from '@chakra-ui/react';
import EmptyState from '../../common/EmptyState';
import MessagingPageHeader from '../../components/client/messages/MessagingPageHeader';
import { MessagingHistoryContextProvider } from '../../store/client/MessagingHistoryContext';
import MessageHistoryView from './MessageHistoryView';
import type { MessagingEntity } from '../../components/client/messages/messagingHistory.types';

interface MessageLogsViewProps {
  selectedEntity?: MessagingEntity;
  statusComponents?: ReactNode;
  shouldRender: boolean;
}

const MessageLogsView = ({
  selectedEntity,
  statusComponents,
  shouldRender,
}: MessageLogsViewProps) => (
  <Container display="flex" flexDir="column" flex="1" pb={6}>
    <MessagingPageHeader />
    {statusComponents}
    {shouldRender &&
      (selectedEntity ? (
        <MessagingHistoryContextProvider>
          <MessageHistoryView
            filterEntity={selectedEntity}
            status=""
            heading="Message history"
          />
        </MessagingHistoryContextProvider>
      ) : (
        <Container display="flex" flexDir="column" flexGrow="1">
          <EmptyState
            heading="No data available."
            text="Please select an entity to view the messaging history."
          />
        </Container>
      ))}
  </Container>
);

export default MessageLogsView;
